import * as React from 'react';

const ChevronLastChunkySvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={24} height={24} {...props}>
        <path d="M8.415 17L7 15.585 10.586 12 7 8.414 8.415 7l4.999 5-4.999 5zm5.999 0V7h2v10h-2z" />
    </svg>
);

ChevronLastChunkySvg.displayName = 'ChevronLastChunkySvg';
export default ChevronLastChunkySvg;
